var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19158",
    "data-name": "Group 19158",
    transform: "translate(-1649 -823)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11211",
    "data-name": "Rectangle 11211",
    width: 25,
    height: 25,
    transform: "translate(1649 823)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye-off",
    "data-name": "Icon feather-eye-off",
    transform: "translate(1651 825.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M17.451,19.126a9.482,9.482,0,0,1-5.593,1.94C5.266,21.066,1.5,13.533,1.5,13.533A17.373,17.373,0,0,1,6.265,7.94m7.589,7.589a2.825,2.825,0,1,1-3.992-3.992",
    transform: "translate(-1.5 -3.175)",
    fill: "none",
    stroke: "#777777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35491",
    "data-name": "Path 35491",
    d: "M1.5,9.879A9.482,9.482,0,0,1,7.093,7.94c6.591,0,10.358,7.533,10.358,7.533a17.373,17.373,0,0,1-4.765,5.593M5.1,13.476a2.825,2.825,0,1,1,3.992,3.992",
    transform: "translate(3.158 -5.027)",
    fill: "none",
    stroke: "#777777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.7896e77e493663455ec4ca8c3257f253.svg";
export { ForwardRef as ReactComponent };